import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { appActions } from '../../app.actions';
import { BaseEffects } from '../../base.effects';

import { CompanyUsersStateActions } from './company-users-state.actions';
import { CompanyUserListModel } from './company-users-state.model';

const apiV4 = 'api/v4';
@Injectable()
export class CompanyUsersStateEffects extends BaseEffects {
  private action$ = inject(Actions);

  logInSuccess_fetchCompanyUsers$ = this.mapEffect({
    action: appActions.setTier1Data,
    mapFn: () => CompanyUsersStateActions.fetch(),
  });

  fetch$ = createEffect(() =>
    this.action$.pipe(
      ofType(CompanyUsersStateActions.fetch),
      switchMap(() =>
        this.http
          .get<CompanyUserListModel[]>(`${apiV4}/UserCompanies`)
          .pipe(map(companyUsers => CompanyUsersStateActions.fetchSuccess({ companyUsers })))
      )
    )
  );
}
